import React from 'react';
import axios from 'axios';
import { API } from '../lib/api';
import CustomerAvatarCard from './customer/CustomerAvatarCard';
import CustomerProfileForm from './customer/CustomerProfileForm';
import CustomerPasswordForm from './customer/CustomerPasswordForm';
import CustomerDangerZone from './customer/CustomerDangerZone';

/**
 * Composer for the customer profile page. Each section is a self-contained
 * component under `./customer/`. The legacy localStorage token is still
 * attached to the axios client during the cookie-migration transition window;
 * the cookie alone is what authenticates new sessions.
 */
const CustomerProfilePanel = ({ user, onUpdated, onDeleted }) => {
  const token = typeof window !== 'undefined' ? localStorage.getItem('tgmart_token') : null;
  const authClient = axios.create({
    baseURL: API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });

  return (
    <div className="space-y-6" data-testid="customer-profile-panel">
      <CustomerAvatarCard user={user} authClient={authClient} onUpdated={onUpdated} />
      <CustomerProfileForm user={user} authClient={authClient} onUpdated={onUpdated} />
      <CustomerPasswordForm authClient={authClient} />
      <CustomerDangerZone authClient={authClient} onDeleted={onDeleted} />
    </div>
  );
};

export default CustomerProfilePanel;
